import type { DataResponse, OAuthClient, OAuthClientCreate, OAuthClientCreated, OAuthClientUpdate } from "@/types";
import { api } from "../api";

const BASE = "/admin/oauth-clients";

export const oauthClientService = {
  list: () => api.get<DataResponse<OAuthClient[]>>(BASE),

  create: (data: OAuthClientCreate) => api.post<DataResponse<OAuthClientCreated>>(BASE, data),

  update: (uuid: string, data: OAuthClientUpdate) => api.patch<DataResponse<OAuthClient>>(`${BASE}/${uuid}`, data),

  remove: (uuid: string) => api.delete<void>(`${BASE}/${uuid}`),
};
